import { ServiceRoute } from "./../../base/service-route";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";
import { IPlacementType } from "src/app/interfaces/placementType";

@Injectable({
  providedIn: "root"
})
export class PlacementTypeService {
  constructor(private core: CoreService) { }

  list(packageId: number, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.placementType.list + packageId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listWithDeactive(packageId: number, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.placementType.list + packageId + "&ShowDeactive=true",
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listAll(packageId: number, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.placementType.listAll + packageId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  add(data: IPlacementType): Observable<any> {
    return this.core.post(
      ServiceRoute.placementType.add,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.placementType.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  activeDeactive(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.placementType.activeDeactive,
      new CommonHttpOption().headers,
      data
    );
  }
}
